import { CspConfig } from 'data/cspConfig/cspConfig.types';
import { FormTemplateOption } from 'data/template/template.types';

export const CSP_NONE_OPTION: FormTemplateOption = { label: 'None', value: '' };

/**
 * A team can belong to one or no CSP, so 'None' is always the first option.
 * A team's CSP that is no longer in the list is kept so it still displays.
 */
export default function getCspOptions(
  cspConfigs: CspConfig[] = [],
  currentCspId?: string | null,
): FormTemplateOption[] {
  const options = cspConfigs.map(({ name, cspid }) => ({ label: name, value: cspid }));
  if (currentCspId && !options.some(({ value }) => value === currentCspId)) {
    options.push({ label: currentCspId, value: currentCspId });
  }
  return [CSP_NONE_OPTION, ...options];
}
